import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {DELETE_POSTS_ERROR, DELETE_POSTS_START, DELETE_POSTS_SUCCESS} from "../../types";

export function* deletePosts({payload}) {
    try {
        const url = `/posts/${payload.id}/`;
        const method = 'DELETE';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'application/json'};
        const results = yield call(apiCall, url, method, payload.formData, headers);
        yield put({type: DELETE_POSTS_SUCCESS, results: results.data});
    } catch (error) {
        yield put({type: DELETE_POSTS_ERROR, error});
    }
}

export default function* delete_posts() {
    yield takeLatest(DELETE_POSTS_START, deletePosts);
}